export default {
  // Page title
  'manualTag.title': 'Gestión de Etiquetas Manual',

  // Form fields
  'manualTag.form.tagName': 'Nombre de Etiqueta',
  'manualTag.form.tagNamePlaceholder': 'Por favor ingrese nombre de etiqueta',
  'manualTag.form.tagNameRequired': 'El nombre de etiqueta es requerido',
  'manualTag.form.tagNameMaxLength': 'El nombre de etiqueta no puede exceder 50 caracteres',
  'manualTag.form.tagDescription': 'Descripción de Etiqueta',
  'manualTag.form.tagDescriptionPlaceholder': 'Por favor ingrese descripción de etiqueta (opcional, solo visible en backend)',
  'manualTag.form.tagDescriptionMaxLength': 'La descripción de etiqueta no puede exceder 255 caracteres',
  'manualTag.form.currencyScope': 'Monedas Aplicables',
  'manualTag.form.currencyPlaceholder': 'Por favor seleccione monedas aplicables',
  'manualTag.form.currencyFilterPlaceholder': 'Todas las monedas',
  'manualTag.form.currencyRequired': 'Seleccione al menos una moneda',

  // Table fields
  'manualTag.table.tagName': 'Nombre de Etiqueta',
  'manualTag.table.currencyScope': 'Monedas Aplicables',
  'manualTag.table.tagDescription': 'Descripción',
  'manualTag.table.hitCount': 'Cantidad de Coincidencias',
  'manualTag.table.createTime': 'Hora de Creación',
  'manualTag.table.action': 'Acción',

  // Action buttons
  'manualTag.action.create': 'Crear Etiqueta',
  'manualTag.action.editTags': 'Editar Etiquetas',

  // Modal titles
  'manualTag.modal.createTitle': 'Crear Etiqueta',
  'manualTag.modal.editTitle': 'Editar Etiqueta',
  'manualTag.modal.editMemberTagTitle': 'Editar Etiquetas de Miembro',
  'manualTag.modal.editHint': 'Haga clic en la casilla de verificación para añadir o eliminar etiquetas para el miembro',

  // Messages
  'manualTag.message.createSuccess': 'Etiqueta creada exitosamente',
  'manualTag.message.createFailed': 'Error al crear etiqueta',
  'manualTag.message.updateSuccess': 'Actualización exitosa',
  'manualTag.message.updateFailed': 'Actualización fallida',
  'manualTag.message.deleteSuccess': 'Etiqueta eliminada exitosamente',
  'manualTag.message.deleteFailed': 'Error al eliminar etiqueta',
  'manualTag.message.deleteConfirm': '¿Está seguro de que desea eliminar esta etiqueta?',
  'manualTag.message.deleteWarning': 'Después de la eliminación, todos los miembros con esta etiqueta la tendrán eliminada',

  // Other
  'manualTag.noTags': 'Sin etiquetas',
  'manualTag.noTagsAvailable': 'Sin etiquetas disponibles, por favor cree etiquetas en gestión de etiquetas primero',
};
